import { useQueryClient } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { USER_QUERY_STALE_TIME } from "@/common/const/query-cache";
import { BASE_API } from "@/environments";

export function useLoadConsultoresPaginate() {
  const queryClient = useQueryClient();
  const { token } = useStoreZustandUserAuth();

  return async (inputValue: string, _prevOptions: any, additional: { page: number }) => {
    const queryKey = ["usuarios-consultores", inputValue, additional.page];

    const result = await queryClient.fetchQuery({
      queryKey,
      queryFn: () =>
        fetch(
          `${BASE_API}/users/consultores?search=${inputValue}&page=${additional.page}&per_page=10`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        ).then((res) => res.json()),
      staleTime: USER_QUERY_STALE_TIME,
    });

    const options = result.data.map((user: any) => ({
      value: user.id,
      label: user.nome,
    }));

    return {
      options,
      hasMore: result.pagination.current_page < result.pagination.last_page,
      additional: {
        page: additional.page + 1,
      },
    };
  };
}
